import { toast } from "react-toastify";
import { endpoints } from "../../../configs/Settings";
import { HTTPResponseStatus } from "../../../utils/enum";
import { IPatchOperation } from "../../../utils/interfaces";
import { useAuth } from "../../../utils/useAuth";
import { useAxios } from "../../../utils/useAxios";
import { auxiliarData } from "../AuxiliarData";

export type ObservationPatchStatus = "entered-in-error" | "final" | "cancelled";

interface IProps {
  observationId: string;
  status?: ObservationPatchStatus;
}

/**
 * PATCH individual no EHRPoster (formato aceito pelo servidor).
 * Reutilizado em lote por `PatchWearableObservationsStatusBatch`.
 */
export async function patchObservationStatusEhrPoster({
  observationId,
  status,
}: IProps) {
  const url = `${endpoints.EHRPOSTER}/Observation/${observationId}`;

  const operations: IPatchOperation[] = [];
  if (status) {
    operations.push({
      op: "replace",
      path: "/status",
      value: status,
    });
  }

  const data = auxiliarData.Patch({ operations });
  const headers = {
    Accept: "application/fhir+json",
    Authorization: await useAuth.getUserToken(),
    "Content-Type": "application/json-patch+json",
  };

  const response = await useAxios.patch(url, data, { headers, timeout: 8000 });
  if (response.status !== HTTPResponseStatus.Success) {
    throw new Error(`patchObservationStatusEhrPoster: ${response.status}`);
  }
  return { data: response.data, status: response.status };
}

export async function PatchStatusObservation(props: IProps) {
  try {
    return await patchObservationStatusEhrPoster(props);
  } catch (error) {
    console.error("PatchStatusObservation ", error);
    toast.error(
      `PatchStatusObservation Error: ${(error as { response?: { status?: number } })?.response?.status}`,
    );
    throw new Error();
  }
}
